import React from "react";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";

const MDTextField = ({
  name,
  value,
  onChange,
  onBlur,
  label,
  fullWidth = true,
  multiline = false,
  rows = 1,
  variant = "standard",
  required = false,
  ...rest
}) => {
  return (
    <TextField
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      label={
        <span>
          {label} {required && <span style={{ color: "red" }}>*</span>}
        </span>
      }
      fullWidth={fullWidth}
      multiline={multiline}
      rows={multiline ? rows : undefined}
      variant={variant}
      {...rest}
      sx={{
        "& .MuiInputLabel-root": {
          paddingTop: "6px",
          paddingBottom: "6px",
          fontSize: "0.875rem",
        },
        "& .MuiInputBase-root": {
          paddingTop: "10px",
        },
      }}
    />
  );
};

MDTextField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  label: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  variant: PropTypes.string,
  required: PropTypes.bool,
};

export default MDTextField;
